import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { DOCUMENT_TYPES_ACTION_TYPE } from '../actions';

const initialState = {};

const documentTypesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case DOCUMENT_TYPES_ACTION_TYPE.GET_DOCUMENT_TYPES:
        return payload || initialState;

      case DOCUMENT_TYPES_ACTION_TYPE.GET_DOCUMENT_TYPE:
      case DOCUMENT_TYPES_ACTION_TYPE.CREATE_DOCUMENT_TYPE:
      case DOCUMENT_TYPES_ACTION_TYPE.EDIT_DOCUMENT_TYPE:
        draft[payload.id] = payload;
        break;

      case DOCUMENT_TYPES_ACTION_TYPE.DELETE_DOCUMENT_TYPE:
        delete draft[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default documentTypesReducer;
